
module.exports = {
    encode: require('./encode'),
    decode: require('./decode')
};



//////////////////
// WEBPACK FOOTER
// ../~/markup-it/lib/json/index.js
// module id = 790
// module chunks = 0